import { Loader2 } from 'lucide-react';
import { forwardRef } from 'react';
import { useTranslation } from 'react-i18next';

interface InfiniteScrollIndicatorI {
    isLoading: boolean;
}
const InfiniteScrollIndicator = forwardRef<HTMLDivElement, InfiniteScrollIndicatorI>((props, ref) => {
    const { t } = useTranslation();
    return (
        <div ref={ref} className="w-full flex justify-center py-4">
            {props.isLoading ? (
                <div className="flex items-center gap-2">
                    <Loader2 className="h-5 w-5 animate-spin text-primary" />
                    <span className="text-sm text-muted-foreground">{t('knowledgeManager.loadingInfinite')}</span>
                </div>
            ) : (
                <div className="h-8" /> // Espacio para detectar el scroll
            )}
        </div>
    );
});

export default InfiniteScrollIndicator;
